import { render, staticRenderFns } from "./BadgeMarketingKit.vue?vue&type=template&id=07f4302b&scoped=true&"
import script from "./BadgeMarketingKit.vue?vue&type=script&lang=js&"
export * from "./BadgeMarketingKit.vue?vue&type=script&lang=js&"
import style0 from "./BadgeMarketingKit.vue?vue&type=style&index=0&id=07f4302b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4302b",
  null
  
)

export default component.exports